const PATIENT_ENROLLMENT_SUSPENSION_STATUS = [
  { suspensionStatus: 0, title: 'Active' },
  { suspensionStatus: 1, title: 'On Hold' },
  { suspensionStatus: 2, title: 'Stopped' }
];

type PATIENT_ENROLLMENT_SUSPENSION_STATUS = typeof PATIENT_ENROLLMENT_SUSPENSION_STATUS;

export default PATIENT_ENROLLMENT_SUSPENSION_STATUS;
